import React from "react";
import PropTypes from "prop-types";
import { currencyTypes, currencies, defaultDecimalPlaces } from "./../../constants";

const allCurrencies = {};

Object.keys(currencies).forEach((currencyType) => {
  Object.keys(currencies[currencyType]).forEach((currency) => {
    allCurrencies[currency] = {
      type: currencyType,
      code: currency
    };
  });
});

// Helper function to format specific to Swedish locale (1 234,56)
// We use this to replace .toFixed() while keeping the rest of your logic intact.
const toSwedish = (number, decimals) => {
  return new Intl.NumberFormat('sv-SE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true // This adds the space separator (e.g. 1 000)
  }).format(number);
};

export default function FormattedAmount({ children, currency, monospace }) {
  if (allCurrencies[currency].type === currencyTypes.CRYPTO) {
    const value = toSwedish(children, defaultDecimalPlaces.crypto);
    
    return monospace ? (
      <span className="currency-font">
        {`${value} ${currency}`}
      </span>
    ) : (
      `${value} ${currency}`
    );
  }

  if (allCurrencies[currency].type === currencyTypes.FIAT) {
    const value = toSwedish(children, defaultDecimalPlaces.fiat);

    return monospace ? (
      <span className="currency-font">
        {`${value} ${currency}`}
      </span>
    ) : (
      `${value} ${currency}`
    );
  }

  return null;
}

FormattedAmount.propTypes = {
  children: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired
};
